import sharedLabel from '../translation'
import {BidState} from '../types/Bids'
import type {ILabel} from '../../../types'

export default {
    ...sharedLabel,
    productCouldNotBeAddedToCart: <ILabel>{
        de: 'Das Produkt konnte nicht in den Warenkorb gelegt werden.',
        en: 'The product could not be added to the cart',
        es: 'El producto no se ha podido añadir a la cesta de la compra.',
        fr: 'Le produit n\'a pas pu être ajouté au panier.',
        nl: 'Het product kon niet worden toegevoegd aan de winkelmandje',
        it: 'Non è stato possibile aggiungere il prodotto al carrello.',
    },
    notificationBid: (state: BidState): ILabel => {
        if(state === BidState.confirmed) {
            return {
                de: 'Ihr Gebot war erfolgreich',
                en: 'Your bid was successful',
                es: 'Su puja ha sido aceptada',
                fr: 'Votre enchère a été finalisée avec succès.',
                nl: 'Uw bod is geslaagd',
                it: 'La Sua offerta é avvenuta con successo',
            }
        }
        if(state === BidState.denied) {
            return {
                de: 'Ihr Gebot wurde leider abgelehnt',
                en: 'Unfortunately, your bid was not successful',
                es: 'Lamentablemen no se ha podido aceptar su puja',
                fr: 'Votre offre n\'a malheureusement pas été prise en compte',
                nl: 'Uw bod is helaas niet geslaagd',
                it: 'La Sua offerta non ha avuto successo',
            }
        }
        return {
            de: 'de: undefined label',
            en: 'en: undefined label',
            es: 'es: undefined label',
            fr: 'fr: undefined label',
            nl: 'nl: undefined label',
            it: 'it: undefined label',
        }
    }
}